import { useEffect, useState } from "react";
import { Instagram, Heart, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_POSTS } from "@/data/instagram";
import { fetchInstagramFeed } from "@/lib/api";

export default function InstagramGrid() {
  const [posts, setPosts] = useState(INSTAGRAM_POSTS);

  useEffect(() => {
    fetchInstagramFeed()
      .then((data) => { if (Array.isArray(data) && data.length) setPosts(data); })
      .catch(() => {});
  }, []);

  return (
    <section className="bg-ink text-cream py-14 sm:py-20 border-t border-cream/10" data-testid="instagram-grid-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 sm:mb-10">
          <div>
            <p className="eyebrow">Latest from the Grid</p>
            <h2 className="mt-2 font-serif-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-cream">
              @sip_alchemy_ this <span className="italic font-serif-editor text-pink-brand">week.</span>
            </h2>
          </div>
          <a
            href="https://instagram.com/sip_alchemy_"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-pill btn-pink"
            data-testid="ig-grid-follow"
          >
            <Instagram size={16} /> Follow
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          {posts.slice(0, 8).map((p) => (
            <a
              key={p.id}
              href={p.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square rounded-xl overflow-hidden card-ink img-scrim"
              data-testid={`ig-post-${p.id}`}
            >
              <img src={p.image} alt={p.caption} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 p-4 flex flex-col justify-end text-cream z-10">
                <p className="text-xs sm:text-sm font-body leading-snug line-clamp-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-shadow-lift">{p.caption}</p>
                <div className="mt-2 flex items-center justify-between text-[10px] uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {p.likes ? <span className="flex items-center gap-1"><Heart size={11} fill="currentColor" className="text-pink-brand" /> {p.likes}</span> : <span />}
                  <ArrowUpRight size={14} />
                </div>
              </div>
              <div className="absolute top-3 right-3 h-8 w-8 rounded-full bg-cream/10 backdrop-blur grid place-items-center text-cream group-hover:bg-pink group-hover:text-cream transition-colors z-10">
                <Instagram size={14} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
